var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-tag',{attrs:{"superTag":_vm.isSuperTag}},[(_vm.isSuperTag)?_c('v-icon',{staticClass:"pl-1",attrs:{"left":"","x-small":""},domProps:{"textContent":_vm._s('far fa-sparkles')}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n        "+_vm._s(_vm.sanitizedName)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }